import NotificationWrapper from './Notification';

export default NotificationWrapper;
